const leftRightMargin = right => {
	let margin = 'margin: 0.5em;'
	if (right) {
		return margin + 'margin-right: 0;'
	} else {
		return margin + 'margin-left: 0;'
	}
}

const alignRow = rightText => {
	if (rightText) {
		return 'flex-direction: row;'
	} else {
		return `
			flex-direction: row-reverse;
			justify-content: flex-end;
		`
	}
}

const isDisabled = disabled => {
	if (disabled) {
		return `
			cursor: not-allowed;
			opacity: 0.7;
		`
	} else {
		return `
			cursor: pointer;
		`
	}
}

export { leftRightMargin, alignRow, isDisabled }



// WEBPACK FOOTER //
// ./src/artzu-ui/src/CheckBox/checkBoxHelpers.js